import React, { useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import ChatBot from '../ChatBot';

const SubPageLayout = ({ children, publicCopy = false }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[var(--paper)]">
      <Header />
      <main id="main-content" className={`hbk-subpage-main${publicCopy ? ' hbk-public-copy' : ''}`} tabIndex={-1}>{children}</main>
      <ChatBot />
      <Footer />
    </div>
  );
};

export default SubPageLayout;
